// return-message-show.js (整合版)
// 说明：整合了图片打开、rma 订单详情、子状态列表、时间线、pre_refund_confirm 操作
// 并增加了：基于两个接口联合判断 is_pre_refund_confirm 与 is_show_pre_refund_confirm_after 显示不同样式/图标

const rmaId = getQueryParam("rma_id"); // 获取 URL rma_id

// ====== 全局缓存两份接口数据（当两份数据都存在时可进行联合判断） ======
let _rmaOrderInfo = null; // 来自 getRmaOrderItemInfo 的 rma_order
let _subStatusListData = null; // 来自 order_sub_status_list 的 data（注意结构：data.data...）

// ================== 图片查看：.view-way-bill-pic 点击 ==================
document.querySelectorAll(".view-way-bill-pic").forEach((btn) => {
  btn.addEventListener("click", async (e) => {
    e.preventDefault();
    const target = e.currentTarget;
    const images = target.dataset.image; // shipping_label_image

    if (!images) {
      console.warn("缺少 images 参数");
      return;
    }

    try {
      // 请求获取实际图片地址
      const res = await fetch(
        "https://plugin.kriyya.com/api/klaiyi/rma/getImageUrl",
        {
          method: "POST",
          headers: {
            Authorization: "Bearer 6JXquydq6hZG4aJyN8A5",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ images }),
        }
      );

      if (!res.ok) throw new Error(`接口错误 status=${res.status}`);
      const resJson = await res.json();
      console.log("返回的图片地址：", resJson);

      if (
        !resJson.data ||
        !Array.isArray(resJson.data) ||
        !resJson.data.length
      ) {
        console.warn("接口返回的 data 为空");
        return;
      }

      const imageUrl = resJson.data[0];
      localStorage.setItem("refund_waybill_image", imageUrl);

      // 判断屏幕宽度
      if (window.innerWidth <= 768) {
        // ✅ 移动端：跳转新页面
        const currentParams = window.location.search || "";
        const targetUrl = `https://www.klaiyihair.com/pages/refund-view-waybill${currentParams}`;
        window.location.href = targetUrl;
      } else {
        // ✅ PC端：弹窗显示图片 + Download按钮
        let modal = document.querySelector("#waybill-modal");
        console.log("获取到pc弹窗的外框", modal);
        if (!modal) {
          modal = document.createElement("div");
          modal.id = "waybill-modal";
          modal.style.cssText = `
            position: fixed; top:0; left:0; width:100%; height:100%; 
            background: rgba(0,0,0,0.5); display:flex; align-items:center; justify-content:center;
            z-index: 9999;
          `;
          modal.innerHTML = `
            <div style="background:#fff; border-radius:8px; position:relative;" class="waybill-modal-cen">
              <div class="modal-title">Shipping Label<span id="modal-close" style="cursor:pointer;" class="iconfont icon-Close"></span></div>
              <div class="modal-cen"><img id="modal-image" src="${imageUrl}" style="max-width:100%; max-height:70vh; display:block; margin-bottom:10px;" /></div>
              <div class="bill-btn"><button id="modal-download" style="cursor:pointer;" class="down-btn">Download</button></div>
            </div>
          `;
          document.body.appendChild(modal);

          document
            .querySelector("#modal-close")
            .addEventListener("click", () => {
              modal.remove();
            });

          document
            .querySelector("#modal-download")
            .addEventListener("click", async () => {
              const btn = document.querySelector("#modal-download");
              btn.disabled = true;
              const originalText = btn.textContent;
              btn.textContent = "Downloading...";
              btn.style.backgroundColor = "#ccc";

              try {
                const res = await fetch(imageUrl);
                const blob = await res.blob();
                const a = document.createElement("a");
                a.href = URL.createObjectURL(blob);
                a.download =
                  imageUrl.split("/").pop().split("?")[0] || "waybill.png";
                document.body.appendChild(a);
                a.click();
                a.remove();
                URL.revokeObjectURL(a.href);
              } catch (err) {
                console.error("下载失败：", err);
                alert("下载失败");
              } finally {
                btn.disabled = false;
                btn.style.backgroundColor = "";
                btn.textContent = originalText;
              }
            });
        } else {
          // document.querySelector("#modal-image").src = imageUrl;
          // modal.style.display = "flex";
        }
      }
    } catch (err) {
      console.error("请求失败：", err);
    }
  });
});

// document.querySelectorAll(".view-way-bill-pic").forEach(btn => {
//   btn.addEventListener("click", async (e) => {
//     e.preventDefault();

//     const target = e.currentTarget;
//     const images = target.dataset.image; // shipping_label_image
//     if (!images) {
//       console.warn("缺少 images 参数");
//       return;
//     }

//     try {
//       const res = await fetch("https://plugin.kriyya.com/api/klaiyi/rma/getImageUrl", {
//         method: "POST",
//         headers: {
//           "Authorization": "Bearer 6JXquydq6hZG4aJyN8A5", // TODO: 改为安全的token管理方式
//           "Content-Type": "application/json"
//         },
//         body: JSON.stringify({ images })
//       });

//       if (!res.ok) throw new Error(`接口错误 status=${res.status}`);

//       const resJson = await res.json();
//       console.log("返回的图片地址：", resJson);

//       if (resJson.data && Array.isArray(resJson.data) && resJson.data.length) {
//         // ✅ 获取第一张图片地址
//         const imageUrl = resJson.data[0];

//         // ✅ 保存到 localStorage，跨页面传递
//         localStorage.setItem("refund_waybill_image", imageUrl);

//         // ✅ 携带当前参数跳转
//         const currentParams = window.location.search || "";
//         if(jQuery(window).width()<=768){
//           const targetUrl = `https://www.klaiyihair.com/pages/refund-view-waybill${currentParams}`;
//           window.location.href = targetUrl;
//         }
//       } else {
//         console.warn("接口返回的 data 为空");
//       }
//     } catch (err) {
//       console.error("请求失败：", err);
//     }
//   });
// });

// ================== 本地缓存读取函数 ==================
function getLatestRmaOrderData() {
  const str = localStorage.getItem("rma_order_data");
  const rmaOrderData = JSON.parse(str);
  console.log("进入到储存函数", rmaOrderData);
  try {
    if (rmaOrderData) {
      console.log("取到的 rma_order 数据（来自 localStorage）：", rmaOrderData);

      // 保持你原有的界面调整逻辑（隐藏/显示按钮、设置文本等）
      const btn = document.querySelector(".show-information-money-btn");
      const btn_word_tips = document.querySelector(".button-instruction");
      if (rmaOrderData.shipping_label_image) {
        // 如果货运单存在显示查看货运单的按钮
        // ✅ 批量给所有 .view-way-bill-pic 元素赋值并添加点击事件
        const wayBillBtns = document.querySelectorAll(".view-way-bill-pic");
        if (wayBillBtns.length > 0) {
          wayBillBtns.forEach((billBtn) => {
            // 设置 data-image
            if (rmaOrderData.shipping_label_image) {
              billBtn?.classList.remove("hidden");
              billBtn.dataset.image = rmaOrderData.shipping_label_image;
            }
          });
        }
      }
      // if (Number(rmaOrderData.is_pre_refund_confirm) === 1 || Number(rmaOrderData.is_pre_refund_confirm) === 2) {
      //   if (btn) btn.classList.add("hidden");
      //   console.log('进入if');
      //   if (btn_word_tips) btn_word_tips.classList.add("hidden");
      //   document.querySelector(".button-instructions")?.classList.add("hidden");
      //   document.querySelector(".show-information-money")?.classList.add("hidden");
      //   document.querySelector(".warning-icon-title-three")?.classList.remove("hidden");
      //   document.querySelector(".has-sub-state .empty-height")?.classList.remove("hidden");
      //   const warningEls = document.querySelectorAll('.warning-icon-title');
      //   if (warningEls.length) {
      //     warningEls.forEach(el => el.textContent = "Request Submitted" );
      //   }
      //   // document.querySelector(".has-sub-state .warning-icon-title") &&(document.querySelector(".has-sub-state .warning-icon-title").textContent = "Request Submitted");
      //   const oldSvg = document.querySelector('.has-sub-state svg');
      //   if (oldSvg) {
      //     oldSvg.outerHTML = `
      //       <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
      //         <path fill-rule="evenodd" clip-rule="evenodd"
      //           d="M17.0002 33.6668C26.2049 33.6668 33.6668 26.2049 33.6668 17.0002C33.6668 7.79542 26.2049 0.333496 17.0002 0.333496C7.79542 0.333496 0.333496 7.79542 0.333496 17.0002C0.333496 26.2049 7.79542 33.6668 17.0002 33.6668ZM21.9496 11.9496C22.4378 11.4615 23.2292 11.4615 23.7174 11.9496C24.2055 12.4378 24.2055 13.2292 23.7174 13.7174L15.384 22.0507C14.8959 22.5389 14.1044 22.5389 13.6163 22.0507L10.2829 18.7174C9.79479 18.2292 9.79479 17.4378 10.2829 16.9496C10.7711 16.4615 11.5626 16.4615 12.0507 16.9496L14.5002 19.3991L21.9496 11.9496Z"
      //           fill="#00CC13"/>
      //       </svg>
      //     `;
      //   }
      //   if (Number(rmaOrderData.is_pre_refund_confirm) === 2) {
      //     document.querySelector(".warning-icon-title-three") &&(document.querySelector(".warning-icon-title-three").textContent = "There will be customer concatcing you soon");
      //   }
      // } else {
      //   console.log('进入else');
      //   if(rmaOrderData.request_type == 1){
      //     console.log('001');
      //     // 仅退款
      //     const warningEls = document.querySelectorAll('.warning-icon-title');
      //     if (warningEls.length) {
      //       warningEls.forEach(el => el.textContent = "Your Application is Submited" );
      //     }
      //     // document.querySelector(".no-sub-state .warning-icon-title") &&(document.querySelector(".no-sub-state .warning-icon-title").textContent = "Your Application is Submited");

      //   }else if(rmaOrderData.request_type == 2){
      //     // 退货退款
      //   }
      //   if (btn) btn.classList.remove("hidden");
      //   if (btn_word_tips) btn_word_tips.classList.remove("hidden");
      // }

      // 包装状态
      if (rmaOrderData.package_opened == 0) {
        console.log("未拆开");
        document.querySelector(
          ".return-types .Status-item .message-word"
        ).textContent = "Unused";
      } else {
        console.log("已拆开");
        document.querySelector(
          ".return-types .Status-item .message-word"
        ).textContent = "Used";
      }

      // 请求类型
      if (rmaOrderData.request_type == 1) {
        console.log("退款类型", rmaOrderData.request_type);
        document.querySelector(
          ".return-types .return-request-types-cen .request-type .message-word"
        ).textContent = "Refund (No Returns Required)";
      } else if (rmaOrderData.request_type == 2) {
        document.querySelector(
          ".return-types .return-request-types-cen .request-type .message-word"
        ).textContent = "Refund (With Returns)";
      } else if (rmaOrderData.request_type == 3) {
        document.querySelector(
          ".return-types .return-request-types-cen .request-type .message-word"
        ).textContent = "Exchange Product";
      }

      // 理由
      if (rmaOrderData.reason) {
        console.log("退款理由", rmaOrderData.reason);
        let reasonText = rmaOrderData.reason;
        if (rmaOrderData.reason_sub)
          reasonText += " -- " + rmaOrderData.reason_sub;
        document.querySelector(
          ".return-types .Reason-type .message-word"
        ).textContent = reasonText;
      }

      // 评论上传图片渲染
      // 评论上传图片/视频渲染
      const container = document.querySelector(".message-pic-cen");

      if (container) {
        container.innerHTML = "";
        let hasMedia = false;

        if (Array.isArray(rmaOrderData.rma_comment)) {
          rmaOrderData.rma_comment.forEach((comment) => {
            if (comment.attachments) {
              // 逗号分割多个附件链接
              const attachments = comment.attachments
                .split(",")
                .map((url) => url.trim())
                .filter((url) => url.length > 0);

              attachments.forEach((fileUrl) => {
                const fileExtension = fileUrl
                  .split("?")[0]
                  .split(".")
                  .pop()
                  .toLowerCase();
                console.log("返回的内容", fileExtension);
                // 🎥 视频
                if (["mp4", "webm", "ogg"].includes(fileExtension)) {
                  console.log("包含视频");
                  const video = document.createElement("video");
                  video.src = fileUrl;
                  video.controls = true;
                  video.style.marginRight = "8px";
                  video.style.borderRadius = "6px";
                  container.appendChild(video);
                  hasMedia = true;
                }

                // 🖼️ 图片
                if (
                  ["jpg", "jpeg", "png", "gif", "webp", "avif"].includes(
                    fileExtension
                  )
                ) {
                  console.log("包含图片");
                  const img = document.createElement("img");
                  img.src = fileUrl;
                  img.alt = "Comment Attachment";
                  img.style.height = "auto";
                  img.style.marginRight = "8px";
                  img.style.borderRadius = "6px";
                  container.appendChild(img);
                  hasMedia = true;
                }
              });
            }
          });
        }

        container.style.display = hasMedia ? "" : "none";
      }

      // const container = document.querySelector(".message-pic-cen");
      // if (container) {
      //   container.innerHTML = "";
      //   let hasImage = false;
      //   if (Array.isArray(rmaOrderData.rma_comment)) {
      //     rmaOrderData.rma_comment.forEach((comment) => {
      //       if (comment.attachments) {
      //         const img = document.createElement("img");
      //         img.src = comment.attachments;
      //         img.alt = "Comment Attachment";
      //         container.appendChild(img);
      //         hasImage = true;
      //       }
      //     });
      //   }
      //   container.style.display = hasImage ? "" : "none";
      // }
    }
    return str ? JSON.parse(str) : null;
  } catch (e) {
    console.error("解析 rma_order_data 出错：", e);
    return null;
  }
  // try {
  //   return str ? JSON.parse(str) : null;
  // } catch (e) {
  //   console.error("解析 rma_order_data 出错：", e);
  //   return null;
  // }
}

// ================== 调用 order_sub_status_list 的函数 ==================
async function order_status(rma_id) {
  console.log("进入了子状态接口");
  try {
    const url = new URL(
      "https://plugin.kriyya.com/api/klaiyi/rma/order_sub_status_list"
    );
    if (rma_id) url.searchParams.set("rma_id", rma_id);

    const res = await fetch(url.toString(), {
      method: "GET",
      headers: {
        Authorization: "Bearer 6JXquydq6hZG4aJyN8A5",
        "Content-Type": "application/json",
      },
    });

    if (!res.ok) throw new Error(`接口请求失败，status=${res.status}`);

    const resJson = await res.json();

    let rmaOrderData = null;
    // order_status(rmaId).then((data) => {
    // const data = await res.json();
    console.log("order_status 返回结果：", resJson);
    if (!resJson || !resJson.data) return;

    // 缓存子状态数据（用于联合判断）
    _subStatusListData = resJson.data;
    console.log("子状态数据", _subStatusListData);
    // 收到子状态数据后尝试渲染联合图标
    checkAndShowRefundConfirmIcon();
    const str = await fetchRmaOrderDetailAndCache();

    const new_rmaOrderData = JSON.parse(str);
    console.log("获取rma-ID", new_rmaOrderData);

    // ========== 渲染子状态信息 ==========
    const subStatusInfo = resJson.data?.rma_order_sub_status_info;

    const container = document.querySelector(
      ".sub-state .return-request-types-cen"
    );
    // ⭐⭐⭐ 每次渲染前先清空，避免重复堆积 ⭐⭐⭐
    if (container) container.innerHTML = "";
    if (new_rmaOrderData) {
      // Tracking Number
      if (new_rmaOrderData.tracking_code) {
        document.querySelector(".sub-state")?.classList.remove("hidden");
        console.log("获取到运单号", new_rmaOrderData.tracking_code);
        // 清空原本的内容
        container.innerHTML += `
          <div class="form-section Tracking-type cen">
            <h3 class="form-title message-title">Tracking Number</h3>
            <div class="message-word">${new_rmaOrderData.tracking_code}</div>
          </div>`;
      }
    }
    if (subStatusInfo && container) {
      document.querySelector(".sub-state")?.classList.remove("hidden");

      // 清空原本的内容
      // container.innerHTML = '';

      // 状态 (Status)
      if (subStatusInfo.son_status_description_show) {
        container.innerHTML += `
          <div class="form-section Status-item cen">
            <h3 class="form-title message-title">Status</h3>
            <div class="message-word">${subStatusInfo.son_status_description_show}</div>
          </div>`;
      }

      // Case Id
      if (subStatusInfo.case_id) {
        container.innerHTML += `
          <div class="form-section CaseId-type cen">
            <h3 class="form-title message-title">Case Id</h3>
            <div class="message-word">${subStatusInfo.case_id}</div>
          </div>`;
      }

      // Condition of Returned Item
      if (subStatusInfo.arrival_status) {
        container.innerHTML += `
          <div class="form-section request-type cen">
            <h3 class="form-title message-title">Condition Of Returned Item
              <svg class="show-condition-popup" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M2.125 9C2.125 5.20304 5.20304 2.125 9 2.125C12.797 2.125 15.875 5.20304 15.875 9C15.875 12.797 12.797 15.875 9 15.875C5.20304 15.875 2.125 12.797 2.125 9ZM9 0.875C4.51269 0.875 0.875 4.51269 0.875 9C0.875 13.4873 4.51269 17.125 9 17.125C13.4873 17.125 17.125 13.4873 17.125 9C17.125 4.51269 13.4873 0.875 9 0.875ZM9.9375 13.0625C9.9375 13.5803 9.51777 14 9 14C8.48223 14 8.0625 13.5803 8.0625 13.0625C8.0625 12.5447 8.48223 12.125 9 12.125C9.51777 12.125 9.9375 12.5447 9.9375 13.0625ZM7.9237 4.83909C8.43762 4.62622 9.00312 4.57052 9.54869 4.67904C10.0943 4.78756 10.5954 5.05543 10.9887 5.44876C11.3821 5.8421 11.6499 6.34324 11.7585 6.88881C11.867 7.43438 11.8113 7.99988 11.5984 8.5138C11.3855 9.02771 11.0251 9.46697 10.5625 9.77601C10.2758 9.96761 9.95782 10.1038 9.625 10.1797V10.875H8.375V9.625C8.375 9.45924 8.44085 9.30027 8.55806 9.18306C8.67527 9.06585 8.83424 9 9 9C9.30903 9 9.61113 8.90836 9.86808 8.73667C10.125 8.56498 10.3253 8.32095 10.4436 8.03544C10.5618 7.74993 10.5928 7.43577 10.5325 7.13267C10.4722 6.82958 10.3234 6.55117 10.1049 6.33265C9.88634 6.11413 9.60792 5.96531 9.30483 5.90502C9.00173 5.84473 8.68757 5.87568 8.40206 5.99394C8.11655 6.1122 7.87252 6.31247 7.70083 6.56942C7.52914 6.82638 7.4375 7.12847 7.4375 7.4375V8.0625H6.1875V7.4375C6.1875 6.88124 6.35245 6.33747 6.66149 5.87496C6.97053 5.41245 7.40979 5.05196 7.9237 4.83909Z" fill="#B9B9B9"/>
              </svg>
            </h3>
            <div class="message-word">${subStatusInfo.arrival_status}</div>
          </div>`;
      }

      // Estimated Refund Amount
      if (subStatusInfo.estimated_refund_amount > 0) {
        container.innerHTML += `
          <div class="form-section Reason-type cen">
            <h3 class="form-title message-title">Estimated Refund Amount</h3>
            <div class="message-word">$${subStatusInfo.estimated_refund_amount}</div>
          </div>`;
      }

      // Refund Amount
      if (subStatusInfo.refund_amount > 0) {
        container.innerHTML += `
          <div class="form-section Refund-type cen">
            <h3 class="form-title message-title">Refund Amount</h3>
            <div class="message-word">$${subStatusInfo.refund_amount}</div>
          </div>`;
      }

      // Shipping Company
      if (subStatusInfo.carrier_code) {
        container.innerHTML += `
          <div class="form-section Carrier-type cen">
            <h3 class="form-title message-title">Shipping Company</h3>
            <div class="message-word">${subStatusInfo.carrier_code}</div>
          </div>`;
      }

      // // Tracking Number
      // if (subStatusInfo.tracking_code) {
      //   container.innerHTML += `
      //     <div class="form-section Tracking-type cen">
      //       <h3 class="form-title message-title">Tracking Number</h3>
      //       <div class="message-word">${subStatusInfo.tracking_code}</div>
      //     </div>`;
      // }

      // Product (SKU)
      if (subStatusInfo.sku) {
        container.innerHTML += `
          <div class="form-section Product-type cen">
            <h3 class="form-title message-title">Product</h3>
            <div class="message-word">${subStatusInfo.sku}</div>
          </div>`;
      }
      // -----------------------------
      // ⭐ 从 Name 开始，两列布局渲染
      // -----------------------------

      const twoColumnFields = [];
      if (subStatusInfo.name) {
        twoColumnFields.push({
          title: "Name",
          value: subStatusInfo.name,
          class: "Name-type",
        });
      }

      if (subStatusInfo.phone) {
        twoColumnFields.push({
          title: "Phone Number",
          value: subStatusInfo.phone,
          class: "Phone-type",
        });
      }

      if (subStatusInfo.region) {
        twoColumnFields.push({
          title: "State",
          value: subStatusInfo.region,
          class: "Region-type",
        });
      }

      if (subStatusInfo.country) {
        twoColumnFields.push({
          title: "Country",
          value: subStatusInfo.country,
          class: "Country-type",
        });
      }

      if (subStatusInfo.city) {
        twoColumnFields.push({
          title: "City",
          value: subStatusInfo.city,
          class: "City-type",
        });
      }

      if (subStatusInfo.postcode) {
        twoColumnFields.push({
          title: "Zip Code",
          value: subStatusInfo.postcode,
          class: "Zip-type",
        });
      }

      if (subStatusInfo.street) {
        twoColumnFields.push({
          title: "Address",
          value: subStatusInfo.street,
          class: "Address-type",
        });
      }

      // ⭐ 2 个一组渲染
      if (twoColumnFields.length) {
        let html = '<div class="two-col-wrapper">';

        for (let i = 0; i < twoColumnFields.length; i += 2) {
          const left = twoColumnFields[i];
          const right = twoColumnFields[i + 1];

          html += `
      <div class="two-col-row">
        <div class="form-section ${left.class} cen">
          <h3 class="form-title message-title">${left.title}</h3>
          <div class="message-word">${left.value}</div>
        </div>

        ${
          right
            ? `
        <div class="form-section ${right.class} cen">
          <h3 class="form-title message-title">${right.title}</h3>
          <div class="message-word">${right.value}</div>
        </div>`
            : `<div class="form-section empty"></div>`
        }
      </div>
    `;
        }

        html += "</div>";
        container.innerHTML += html;
      }
      // // Name
      // if (subStatusInfo.name) {
      //   container.innerHTML += `
      //     <div class="form-section Name-type cen">
      //       <h3 class="form-title message-title">Name</h3>
      //       <div class="message-word">${subStatusInfo.name}</div>
      //     </div>`;
      // }

      // // Phone
      // if (subStatusInfo.phone) {
      //   container.innerHTML += `
      //     <div class="form-section Phone-type cen">
      //       <h3 class="form-title message-title">Phone Number</h3>
      //       <div class="message-word">${subStatusInfo.phone}</div>
      //     </div>`;
      // }

      // // Region / State
      // if (subStatusInfo.region) {
      //   container.innerHTML += `
      //     <div class="form-section Region-type cen">
      //       <h3 class="form-title message-title">State</h3>
      //       <div class="message-word">${subStatusInfo.region}</div>
      //     </div>`;
      // }

      // // Country
      // if (subStatusInfo.country) {
      //   container.innerHTML += `
      //     <div class="form-section Country-type cen">
      //       <h3 class="form-title message-title">Country</h3>
      //       <div class="message-word">${subStatusInfo.country}</div>
      //     </div>`;
      // }

      // // City
      // if (subStatusInfo.city) {
      //   container.innerHTML += `
      //     <div class="form-section City-type cen">
      //       <h3 class="form-title message-title">City</h3>
      //       <div class="message-word">${subStatusInfo.city}</div>
      //     </div>`;
      // }

      // // Zip Code
      // if (subStatusInfo.postcode) {
      //   container.innerHTML += `
      //     <div class="form-section Zip-type cen">
      //       <h3 class="form-title message-title">Zip Code</h3>
      //       <div class="message-word">${subStatusInfo.postcode}</div>
      //     </div>`;
      // }

      // // Street / Address
      // if (subStatusInfo.street) {
      //   container.innerHTML += `
      //     <div class="form-section Address-type cen">
      //       <h3 class="form-title message-title">Address</h3>
      //       <div class="message-word">${subStatusInfo.street}</div>
      //     </div>`;
      // }

      // Shipping Details
      if (
        subStatusInfo.shipping_details &&
        Array.isArray(subStatusInfo.shipping_details) &&
        subStatusInfo.shipping_details.length
      ) {
        let shippingHtml = subStatusInfo.shipping_details
          .map(
            (item) => `
          <div class="form-section ShippingDetail-type cen">
            <h3 class="form-title message-title">${item.time}</h3>
            <div class="message-word">${item.status}</div>
          </div>`
          )
          .join("");
        container.innerHTML += shippingHtml;
      }
    } else {
      document
        .querySelector(".warning-icon-title-three")
        ?.classList.add("hidden");
      const warningEls = document.querySelectorAll(".warning-icon-title");
      if (warningEls.length) {
        warningEls.forEach((el) => (el.textContent = "Request Submitted"));
      }
      // document.querySelector(".has-sub-state .warning-icon-title") && (document.querySelector(".has-sub-state .warning-icon-title").textContent = "Your Application In Progress");
    }

    // ========== 渲染时间线（根据 rma_order_sub_status_history 动态生成多个模块） ==========

    const statusWrap = document.querySelector(".status-update.cen");
    if (!statusWrap) return;

    // 清空旧内容（重新渲染）
    statusWrap.innerHTML = "";

    // 获取状态历史数据
    const historyList = resJson.data?.rma_order_sub_status_history || [];
    if (!historyList.length) {
      document.querySelector(".return-request-types").classList.add("hidden");
      document.querySelector(".empty-height-two").classList.add("hidden");
      return;
    }

    // 读取 RMA 主状态（用于判断是否追加 “Waiting...”）

    try {
      rmaOrderData = getLatestRmaOrderData();
    } catch (e) {
      console.warn("rma_order_data 解析失败：", e);
    } // 如果 localStorage 没拿到，尝试从当前接口返回兜底
    if (!rmaOrderData) {
      rmaOrderData = resJson.data?.rma_order_info || {};
    }
    console.log("获取子订单内容", rmaOrderData, rmaOrderData.pre_refund_amount);
    // 如果存在估算退款金额则显示交互按钮区域
    const refundAmount =
      Number(rmaOrderData?.pre_refund_amount) ||
      Number(resJson.data?.rma_order_sub_status_info?.estimated_refund_amount);
    // end if estimated_refund_amount

    // 遍历每个 request_type（如 Return & Refund / Exchange）
    historyList.forEach((historyItem, idx) => {
      const topKeyword = historyItem.request_type_description_show || "—";
      const subList = historyItem.sub_status_list || [];

      // 容器结构
      const cenDiv = document.createElement("div");
      cenDiv.className = "status-update-cen";
      if (idx > 0) cenDiv.classList.add("status-update-bottom"); // ✅ 第二个及之后加上额外class
      cenDiv.innerHTML = `
          <div class="status-update-cen-top">
          <span class="status-update-cen-top-kayword">${topKeyword}</span>
          <span class="status-update-cen-top-data hidden">${
            subList[0]?.created_at_format || "--"
          }</span>
          </div>
          <div class="status-update-cen-bottom">
          <div class="timeline"></div>
          </div>
      `;

      const timelineEl = cenDiv.querySelector(".timeline");

      // 处理 Waiting... 逻辑
      const allSubStatus = [...subList];
      console.log("获取子状态", subList, rmaOrderData);
      // 如果存在 Waiting 状态，插入前排序
      if (
        rmaOrderData &&
        rmaOrderData.status != 3 &&
        rmaOrderData.status != 4
      ) {
        subList.push({
          status_description_show: "Waiting...",
          created_at_format: "--",
          isWaiting: true,
        });
      }

      // 将 isWaiting=true 的项排到最前面
      subList.sort((a, b) => {
        if (a.isWaiting && !b.isWaiting) return -1; // a 在前
        if (!a.isWaiting && b.isWaiting) return 1; // b 在前
        return 0; // 其他保持原顺序
      });
      console.log("获取所有子状态", subList);

      subList.forEach((subStatus, index) => {
        const itemDiv = document.createElement("div");
        let statusClass = "";

        if (index === 0 && !subStatus.isWaiting) statusClass = "active";
        else if (!subStatus.isWaiting) statusClass = "completed";

        // ✅ 生成 status HTML 并添加 waiting class
        const isWaiting = subStatus.status_description_show === "Waiting...";
        const statusHTML = subStatus.status_description_show
          ? `<p class="status${isWaiting ? " waiting" : ""}">${
              subStatus.status_description_show
            }</p>`
          : "";

        const sonStatusHTML = subStatus.son_status_description_show
          ? `<p class="time">${subStatus.son_status_description_show}</p>`
          : "";
        const createdAtHTML = subStatus.created_at_format
          ? `<p class="time">${subStatus.created_at_format}</p>`
          : "";

        itemDiv.className = `timeline-item ${statusClass}`.trim();
        itemDiv.innerHTML = `
              <div class="dot"></div>
              <div class="timeline-content">
                ${statusHTML}
                ${sonStatusHTML}
                ${createdAtHTML}
              </div>
            `;

        timelineEl.appendChild(itemDiv);
      });

      // 把整个模块加进主容器
      statusWrap.appendChild(cenDiv);
    });
    // return resJson;
  } catch (err) {
    console.error("获取订单状态失败：", err);
    return null;
  }
}

// ================== 联合判断并显示图标/样式 ==========
// 逻辑：当 _rmaOrderInfo 存在并且 is_pre_refund_confirm==1 或 2
// 且 _subStatusListData 存在时，检查 is_show_pre_refund_confirm_after
// 如果为1 -> 显示样式 A（绿色勾）
// 如果为0 -> 显示样式 B（橙色/等待）
// UI 采用现有结构（尽量操作 .has-sub-state svg 与 .warning-icon-title-three等）
// 也会确保隐藏/显示与原有行为保持一致
function checkAndShowRefundConfirmIcon() {
  if (!_rmaOrderInfo || !_subStatusListData) return;
  const isPreConfirm = Number(_rmaOrderInfo.is_pre_refund_confirm); // 是否已确认预估退款，1：接受，2：不接受，0：未确认
  const isShowAfter = Number(
    _subStatusListData.is_show_pre_refund_confirm_after
  ); // 1 客服确认中， 0 客服确认完成
  console.log(
    "获取接口返回的值并确认",
    isPreConfirm,
    isShowAfter,
    _subStatusListData.rma_order_sub_status_info,
    _rmaOrderInfo.pre_refund_amount,
    showConfirmRefund()
  );
  // 预估款确认
  // 预估金额确认
  if (Number(_rmaOrderInfo.pre_refund_amount) > 0 && isPreConfirm == 0) {
    const oldSvg = document.querySelector(".has-sub-state svg");
    console.log(
      "预估金额确认,还没有确认过金额",
      _rmaOrderInfo.pre_refund_amount
    );
    document.querySelector(".has-sub-state")?.classList.remove("hidden");
    document.querySelector(".no-sub-state")?.classList.add("hidden");
    const moneyEl = document.querySelector(".show-information-money");
    if (moneyEl) {
      moneyEl.textContent = "$" + _rmaOrderInfo?.pre_refund_amount; // 设置显示的值
    }
    // 运输中
    if (oldSvg) {
      oldSvg.outerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="34" viewBox="0 0 30 34" fill="none">
            <path d="M10.8333 0C9.45262 0 8.33333 1.11929 8.33333 2.5V4.16667C8.33333 5.54738 9.45262 6.66667 10.8333 6.66667H19.1667C20.5474 6.66667 21.6667 5.54738 21.6667 4.16667V2.5C21.6667 1.11929 20.5474 0 19.1667 0H10.8333Z" fill="#000D00"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.83333 3.39436C3.73682 3.51199 2.4133 3.84606 1.46447 4.7949C0 6.25937 0 8.61639 0 13.3304V23.3304C0 28.0445 0 30.4015 1.46447 31.866C2.92893 33.3304 5.28595 33.3304 10 33.3304H20C24.714 33.3304 27.0711 33.3304 28.5355 31.866C30 30.4015 30 28.0445 30 23.3304V13.3304C30 8.61639 30 6.25937 28.5355 4.7949C27.5867 3.84606 26.2632 3.51199 24.1667 3.39436V4.16667C24.1667 6.92809 21.9281 9.16667 19.1667 9.16667H10.8333C8.07191 9.16667 5.83333 6.92809 5.83333 4.16667V3.39436ZM6.66667 19.5833C5.97631 19.5833 5.41667 20.143 5.41667 20.8333C5.41667 21.5237 5.97631 22.0833 6.66667 22.0833H20C20.6904 22.0833 21.25 21.5237 21.25 20.8333C21.25 20.143 20.6904 19.5833 20 19.5833H6.66667ZM6.66667 25.4167C5.97631 25.4167 5.41667 25.9763 5.41667 26.6667C5.41667 27.357 5.97631 27.9167 6.66667 27.9167H15.8333C16.5237 27.9167 17.0833 27.357 17.0833 26.6667C17.0833 25.9763 16.5237 25.4167 15.8333 25.4167H6.66667Z" fill="#000D00"/>
          </svg>
        `;
    }
    document.querySelector(".has-sub-state .warning-icon-title") &&
      (document.querySelector(
        ".has-sub-state .warning-icon-title"
      ).textContent = "Estimated refund amount");
    const btnAccept = document.querySelector(".btn-accept");
    const btnReject = document.querySelector(".btn-accept-no");

    async function preRefundConfirm(is_accept) {
      console.log("点击过取消或者确认按钮", is_accept);
      const url = "https://plugin.kriyya.com/api/klaiyi/rma/pre_refund_confirm";
      try {
        const res = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: "Bearer 6JXquydq6hZG4aJyN8A5",
          },
          body: new URLSearchParams({
            rma_id: rmaId,
            is_accept,
          }).toString(),
        });

        const resJson = await res.json();
        console.log("确认接口返回：", resJson);

        if (resJson.code === 200000) {
          console.log(is_accept == 1 ? "已接受退款金额" : "已拒绝退款金额");

          // 成功后隐藏按钮并显示提交状态（与前面一致）
          document
            .querySelector(".show-information-money-btn")
            ?.classList.add("hidden");
          document
            .querySelector(".button-instruction")
            ?.classList.add("hidden");
          document
            .querySelector(".button-instructions")
            ?.classList.add("hidden");
          document
            .querySelector(".show-information-money")
            ?.classList.add("hidden");
          document
            .querySelector(".warning-icon-title-three")
            ?.classList.remove("hidden");
          document
            .querySelector(".has-sub-state .empty-height")
            ?.classList.remove("hidden");
          document.querySelector(".has-sub-state .warning-icon-title") &&
            (document.querySelector(
              ".has-sub-state .warning-icon-title"
            ).textContent = "Your Application In Progress");

          const oldSvg = document.querySelector(".has-sub-state svg");
          if (oldSvg) {
            oldSvg.outerHTML =
              is_accept == 1
                ? `
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M20 36.6668C28.0603 36.6668 34.5944 30.1939 34.5944 22.2091C34.5944 14.2243 28.0603 7.75131 20 7.75131C11.9397 7.75131 5.40556 14.2243 5.40556 22.2091C5.40556 30.1939 11.9397 36.6668 20 36.6668ZM27.9418 3.51679C27.3722 3.16413 26.6219 3.33566 26.2659 3.89992C25.9099 4.46418 26.083 5.20749 26.6526 5.56015L33.139 9.5762C33.7086 9.92886 34.459 9.75732 34.815 9.19307C35.171 8.62881 34.9978 7.8855 34.4282 7.53284L27.9418 3.51679ZM13.7342 3.89992C14.0902 4.46418 13.917 5.20749 13.3474 5.56015L6.86095 9.5762C6.29136 9.92886 5.54102 9.75732 5.18503 9.19306C4.82903 8.6288 5.00219 7.88549 5.57178 7.53283L12.0582 3.51679C12.6278 3.16413 13.3782 3.33566 13.7342 3.89992ZM20 14.5786C20.6717 14.5786 21.2162 15.118 21.2162 15.7834V21.71L24.914 25.3732C25.389 25.8437 25.389 26.6065 24.914 27.077C24.439 27.5476 23.669 27.5476 23.194 27.077L19.14 23.061C18.9119 22.8351 18.7838 22.5286 18.7838 22.2091V15.7834C18.7838 15.118 19.3283 14.5786 20 14.5786Z" fill="#000D00"/>
                </svg>
              `
                : `
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0ZM18 10H22V22H18V10ZM18 26H22V30H18V26Z"
                    fill="#FF9900"/>
                </svg>
              `;
          }

          if (is_accept == 0) {
            document.querySelector(".warning-icon-title-three") &&
              (document.querySelector(".warning-icon-title-three").textContent =
                "There will be customer contacting you soon");
          }

          // 更新本地缓存中的 rma_order_data.is_pre_refund_confirm，以便后续逻辑判断
          try {
            const localData = getLatestRmaOrderData() || {};
            localData.is_pre_refund_confirm = String(is_accept);
            localStorage.setItem("rma_order_data", JSON.stringify(localData));
            // 同步内存变量（如果有）
            if (_rmaOrderInfo)
              _rmaOrderInfo.is_pre_refund_confirm = String(is_accept);
          } catch (e) {
            console.warn("更新 localStorage rma_order_data 失败：", e);
          }

          // 收到确认后尝试与子状态联合判断（如果子状态数据存在）
          checkAndShowRefundConfirmIcon(moneyEl, is_accept);
        } else {
          console.error(resJson.message || "操作失败，请稍后再试");
        }
      } catch (error) {
        console.error("调用确认接口出错：", error);
      }
    }

    if (btnAccept) {
      btnAccept.addEventListener("click", function () {
        preRefundConfirm(1);
      });
    }
    if (btnReject) {
      btnReject.addEventListener("click", function () {
        preRefundConfirm(0);
      });
    }
  }
  // 预估款确认后
  else if (showConfirmRefund()) {
    console.log("预估金额已确认");
    document.querySelector(".has-sub-state")?.classList.add("hidden");
    document.querySelector(".no-sub-state")?.classList.remove("hidden");
    document.querySelector(
      ".no-sub-state .warning-icon-title-two"
    ).textContent = confirmRefundText();
    const oldSvg = document.querySelector(".no-sub-state svg");
    // 已完成
    if (oldSvg) {
      oldSvg.outerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M20 36.6668C28.0603 36.6668 34.5944 30.1939 34.5944 22.2091C34.5944 14.2243 28.0603 7.75131 20 7.75131C11.9397 7.75131 5.40556 14.2243 5.40556 22.2091C5.40556 30.1939 11.9397 36.6668 20 36.6668ZM27.9418 3.51679C27.3722 3.16413 26.6219 3.33566 26.2659 3.89992C25.9099 4.46418 26.083 5.20749 26.6526 5.56015L33.139 9.5762C33.7086 9.92886 34.459 9.75732 34.815 9.19307C35.171 8.62881 34.9978 7.8855 34.4282 7.53284L27.9418 3.51679ZM13.7342 3.89992C14.0902 4.46418 13.917 5.20749 13.3474 5.56015L6.86095 9.5762C6.29136 9.92886 5.54102 9.75732 5.18503 9.19306C4.82903 8.6288 5.00219 7.88549 5.57178 7.53283L12.0582 3.51679C12.6278 3.16413 13.3782 3.33566 13.7342 3.89992ZM20 14.5786C20.6717 14.5786 21.2162 15.118 21.2162 15.7834V21.71L24.914 25.3732C25.389 25.8437 25.389 26.6065 24.914 27.077C24.439 27.5476 23.669 27.5476 23.194 27.077L19.14 23.061C18.9119 22.8351 18.7838 22.5286 18.7838 22.2091V15.7834C18.7838 15.118 19.3283 14.5786 20 14.5786Z" fill="#000D00"/>
          </svg>
          `;
    }
    document.querySelector(".no-sub-state .warning-icon-title") &&
      (document.querySelector(".no-sub-state .warning-icon-title").textContent =
        "Your Application In Progress");
  } else if (
    (isShowAfter === 0 && _subStatusListData.rma_order_sub_status_info) ||
    _rmaOrderInfo?.status === 3 ||
    _rmaOrderInfo?.status === 4
  ) {
    console.log(
      "预估金额已确认,但是是另一种情况",
      finishIcon(),
      deliveredIcon(),
      carIcon(),
      _subStatusListData,
      _rmaOrderInfo,
      _subStatusListData.rma_order_sub_status_info.son_status_description_show,
      _rmaOrderInfo?.status
    );
    document.querySelector(".has-sub-state")?.classList.add("hidden");
    document.querySelector(".no-sub-state")?.classList.remove("hidden");
    document.querySelector(".warning-icon-title-two")?.classList.add("hidden");
    document.querySelector(".no-sub-state .warning-icon-title") &&
      (document.querySelector(".no-sub-state .warning-icon-title").textContent =
        _subStatusListData.rma_order_sub_status_info.son_status_description_show);
    const oldSvg = document.querySelector(".no-sub-state svg");
    if (finishIcon()) {
      // 已完成
      if (oldSvg) {
        oldSvg.outerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M20.0002 36.6668C29.2049 36.6668 36.6668 29.2049 36.6668 20.0002C36.6668 10.7954 29.2049 3.3335 20.0002 3.3335C10.7954 3.3335 3.3335 10.7954 3.3335 20.0002C3.3335 29.2049 10.7954 36.6668 20.0002 36.6668ZM21.2502 10.0002C21.2502 9.30981 20.6905 8.75016 20.0002 8.75016C19.3098 8.75016 18.7502 9.30981 18.7502 10.0002V10.5281C16.0328 11.0146 13.7502 13.0562 13.7502 15.8335C13.7502 19.0288 16.7715 21.2502 20.0002 21.2502C22.2943 21.2502 23.7502 22.7597 23.7502 24.1668C23.7502 25.5739 22.2943 27.0835 20.0002 27.0835C17.706 27.0835 16.2502 25.5739 16.2502 24.1668C16.2502 23.4765 15.6905 22.9168 15.0002 22.9168C14.3098 22.9168 13.7502 23.4765 13.7502 24.1668C13.7502 26.9441 16.0328 28.9857 18.7502 29.4723V30.0002C18.7502 30.6905 19.3098 31.2502 20.0002 31.2502C20.6905 31.2502 21.2502 30.6905 21.2502 30.0002V29.4723C23.9675 28.9857 26.2502 26.9441 26.2502 24.1668C26.2502 20.9716 23.2289 18.7502 20.0002 18.7502C17.706 18.7502 16.2502 17.2406 16.2502 15.8335C16.2502 14.4264 17.706 12.9168 20.0002 12.9168C22.2943 12.9168 23.7502 14.4264 23.7502 15.8335C23.7502 16.5239 24.3098 17.0835 25.0002 17.0835C25.6905 17.0835 26.2502 16.5239 26.2502 15.8335C26.2502 13.0562 23.9675 11.0146 21.2502 10.5281V10.0002Z" fill="#000D00"/>
          </svg>
          `;
      }
    } else if (deliveredIcon()) {
      // 已交付
      if (oldSvg) {
        oldSvg.outerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
              <path d="M29.2959 7.38603L25.9625 5.63678C23.0365 4.10126 21.5735 3.3335 19.9997 3.3335C18.4259 3.3335 16.9629 4.10125 14.0368 5.63677L10.7035 7.38603C7.74725 8.93739 6.00951 9.84932 4.9325 11.069L19.9997 18.6026L35.0668 11.069C33.9898 9.84932 32.2521 8.9374 29.2959 7.38603Z" fill="#000D00"/>
              <path d="M36.2469 13.2741L21.2497 20.7727V36.5069C22.4462 36.2088 23.8076 35.4944 25.9625 34.3636L29.2959 32.6143C32.882 30.7324 34.675 29.7914 35.6707 28.1006C36.6663 26.4097 36.6663 24.3057 36.6663 20.0976V19.9027C36.6663 16.7482 36.6663 14.7761 36.2469 13.2741Z" fill="#000D00"/>
              <path d="M18.7497 36.5069V20.7727L3.75241 13.2741C3.33301 14.7761 3.33301 16.7482 3.33301 19.9027V20.0976C3.33301 24.3057 3.33301 26.4097 4.32867 28.1006C5.32433 29.7914 7.11739 30.7324 10.7035 32.6143L14.0368 34.3636C16.1917 35.4944 17.5531 36.2088 18.7497 36.5069Z" fill="#000D00"/>
            </svg>
          `;
      }
    } else if (carIcon()) {
      // 运输中
      if (oldSvg) {
        oldSvg.outerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
              <path d="M31.091 27.1359C32.8847 27.1359 34.3584 28.4844 34.3584 30.1253C34.3584 31.7666 32.9089 33.115 31.091 33.115C29.2976 33.115 27.8235 31.789 27.8235 30.1253C27.8235 28.4844 29.273 27.1359 31.091 27.1359ZM4.63762 6.17188H22.4089V28.0123H14.7104C14.0962 26.0566 12.131 24.5958 9.77226 24.5958C7.41354 24.5958 5.44831 26.0341 4.83413 28.0123H2.74582V7.90302C2.74582 6.95886 3.60576 6.17188 4.63762 6.17188ZM9.7723 27.1359C11.5902 27.1359 13.0639 28.4844 13.0398 30.1253C13.0398 31.7666 11.5902 33.115 9.7723 33.115C7.97852 33.115 6.50487 31.789 6.50487 30.1253C6.50483 28.4844 7.95433 27.1359 9.7723 27.1359ZM37.1836 18.5715V28.0123H36.0537C35.4395 26.0566 33.4497 24.5959 31.091 24.5959C28.7326 24.5959 26.7424 26.0342 26.1282 28.0123H24.8799V10.007H27.7989C32.9823 10.0069 37.1836 13.851 37.1836 18.5715ZM27.7989 20.2797H34.3584V18.5715C34.3584 15.7169 31.8282 13.4238 28.7326 13.4238H27.7989V20.2797Z" fill="#000D00"/>
            </svg>
          `;
      }
    } else {
      // 哪种情况都不属于
      if (oldSvg) {
        oldSvg.outerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M19.9997 36.6668C29.2044 36.6668 36.6663 29.2049 36.6663 20.0002C36.6663 10.7954 29.2044 3.3335 19.9997 3.3335C10.7949 3.3335 3.33301 10.7954 3.33301 20.0002C3.33301 29.2049 10.7949 36.6668 19.9997 36.6668ZM24.9491 14.9496C25.4373 14.4615 26.2287 14.4615 26.7169 14.9496C27.205 15.4378 27.205 16.2292 26.7169 16.7174L18.3836 25.0507C17.8954 25.5389 17.1039 25.5389 16.6158 25.0507L13.2825 21.7174C12.7943 21.2292 12.7943 20.4378 13.2825 19.9496C13.7706 19.4615 14.5621 19.4615 15.0502 19.9496L17.4997 22.3991L24.9491 14.9496Z" fill="#00CC13"/>
            </svg>
          `;
      }
    }
  }
  // 刚提交申请，未确认，此时没预估价
  else if (
    (showStartSubmit() && !showConfirmRefund() && _rmaOrderInfo.status === 1) ||
    _subStatusListData.rma_order_sub_status_info === null
  ) {
    console.log("刚提交申请，未确认，此时没预估价");
    document.querySelector(".has-sub-state")?.classList.add("hidden");
    document.querySelector(".no-sub-state")?.classList.remove("hidden");
  }

  // const isPreConfirm = Number(_rmaOrderInfo.is_pre_refund_confirm);// 是否已确认预估退款，1：接受，2：不接受，0：未确认
  // const isShowAfter = Number(_subStatusListData.is_show_pre_refund_confirm_after); // 0 或 1
  //   console.log('获取接口返回的值并确认',isPreConfirm,isShowAfter,_subStatusListData.rma_order_sub_status_info);
  // // 只在已确认/已拒绝（1 或 2）的情况下替换图标/文案
  // if (isPreConfirm === 1 || isPreConfirm === 2) {
  //   // 隐藏确认按钮等（和你之前的逻辑一致）
  //   document.querySelector(".show-information-money-btn")?.classList.add("hidden");
  //   document.querySelector(".button-instruction")?.classList.add("hidden");
  //   document.querySelector(".button-instructions")?.classList.add("hidden");
  //   document.querySelector(".show-information-money")?.classList.add("hidden");
  //   // 一些通用显示调整
  //   document.querySelector(".warning-icon-title-three")?.classList.remove("hidden");
  //   document.querySelector(".has-sub-state .empty-height")?.classList.remove("hidden");
  //   const warningEls = document.querySelectorAll('.warning-icon-title');
  //   if (warningEls.length) {
  //     warningEls.forEach(el => el.textContent = "Request Submitted" );
  //   }
  //   // document.querySelector(".has-sub-state .warning-icon-title") &&(document.querySelector(".has-sub-state .warning-icon-title").textContent = "Request Submitted");
  //   // 根据 is_show_pre_refund_confirm_after 渲染不同图标/提示
  //   const oldSvg = document.querySelector(".has-sub-state svg");
  //   if (isShowAfter === 1) {
  //     // 样式 A：绿色勾（接受后的版本）
  //     if (oldSvg) {
  //       oldSvg.outerHTML = `
  //         <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
  //           <path fill-rule="evenodd" clip-rule="evenodd"
  //             d="M17.0002 33.6668C26.2049 33.6668 33.6668 26.2049 33.6668 17.0002C33.6668 7.79542 26.2049 0.333496 17.0002 0.333496C7.79542 0.333496 0.333496 7.79542 0.333496 17.0002C0.333496 26.2049 7.79542 33.6668 17.0002 33.6668ZM21.9496 11.9496C22.4378 11.4615 23.2292 11.4615 23.7174 11.9496C24.2055 12.4378 24.2055 13.2292 23.7174 13.7174L15.384 22.0507C14.8959 22.5389 14.1044 22.5389 13.6163 22.0507L10.2829 18.7174C9.79479 18.2292 9.79479 17.4378 10.2829 16.9496C10.7711 16.4615 11.5626 16.4615 12.0507 16.9496L14.5002 19.3991L21.9496 11.9496Z"
  //             fill="#00CC13"/>
  //         </svg>
  //       `;
  //     } else {
  //       // 如果找不到原 svg，则在 has-sub-state 中插入
  //       const container = document.querySelector(".has-sub-state");
  //       if (container) {
  //         container.insertAdjacentHTML("afterbegin", `
  //           <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
  //             <path fill-rule="evenodd" clip-rule="evenodd"
  //               d="M17.0002 33.6668C26.2049 33.6668 33.6668 26.2049 33.6668 17.0002C33.6668 7.79542 26.2049 0.333496 17.0002 0.333496C7.79542 0.333496 0.333496 7.79542 0.333496 17.0002C0.333496 26.2049 7.79542 33.6668 17.0002 33.6668ZM21.9496 11.9496C22.4378 11.4615 23.2292 11.4615 23.7174 11.9496C24.2055 12.4378 24.2055 13.2292 23.7174 13.7174L15.384 22.0507C14.8959 22.5389 14.1044 22.5389 13.6163 22.0507L10.2829 18.7174C9.79479 18.2292 9.79479 17.4378 10.2829 16.9496C10.7711 16.4615 11.5626 16.4615 12.0507 16.9496L14.5002 19.3991L21.9496 11.9496Z"
  //               fill="#00CC13"/>
  //           </svg>
  //         `);
  //       }
  //     }
  //     // 设置文字（如果需要更多差异化可在此处扩展）
  //     if(isPreConfirm === 2 ){
  //       document.querySelector(".warning-icon-title-three") &&(document.querySelector(".warning-icon-title-three").textContent = "There will be customer concatcing you soon");
  //     }else{
  //        document.querySelector(".warning-icon-title-three") &&(document.querySelector(".warning-icon-title-three").textContent = "The refund will be issued about within 24-48 hours");
  //     }

  //   } else {
  //     console.log('根据内容去展示');
  //     // 根据内容展示版本
  //       const no_oldSvg = document.querySelector(".no-sub-state svg");
  //       // isShowAfter为0，表示在途
  //       console.log('isShowAfter为0,表示还没有确认');
  //     // 样式 B：橙色/等待（is_show_pre_refund_confirm_after == 0）
  //     if (no_oldSvg) {
  //       console.log('是否含有icon');
  //       if(_subStatusListData.rma_order_sub_status_info){
  //           if(_subStatusListData.rma_order_sub_status_info.son_status_description_show == 'Refund processing' || _subStatusListData.rma_order_sub_status_info.son_status_description_show == 'Refund fulfilled' ){
  //               no_oldSvg.outerHTML = `
  //                   <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
  //                       <path fill-rule="evenodd" clip-rule="evenodd" d="M20.0002 36.6668C29.2049 36.6668 36.6668 29.2049 36.6668 20.0002C36.6668 10.7954 29.2049 3.3335 20.0002 3.3335C10.7954 3.3335 3.3335 10.7954 3.3335 20.0002C3.3335 29.2049 10.7954 36.6668 20.0002 36.6668ZM21.2502 10.0002C21.2502 9.30981 20.6905 8.75016 20.0002 8.75016C19.3098 8.75016 18.7502 9.30981 18.7502 10.0002V10.5281C16.0328 11.0146 13.7502 13.0562 13.7502 15.8335C13.7502 19.0288 16.7715 21.2502 20.0002 21.2502C22.2943 21.2502 23.7502 22.7597 23.7502 24.1668C23.7502 25.5739 22.2943 27.0835 20.0002 27.0835C17.706 27.0835 16.2502 25.5739 16.2502 24.1668C16.2502 23.4765 15.6905 22.9168 15.0002 22.9168C14.3098 22.9168 13.7502 23.4765 13.7502 24.1668C13.7502 26.9441 16.0328 28.9857 18.7502 29.4723V30.0002C18.7502 30.6905 19.3098 31.2502 20.0002 31.2502C20.6905 31.2502 21.2502 30.6905 21.2502 30.0002V29.4723C23.9675 28.9857 26.2502 26.9441 26.2502 24.1668C26.2502 20.9716 23.2289 18.7502 20.0002 18.7502C17.706 18.7502 16.2502 17.2406 16.2502 15.8335C16.2502 14.4264 17.706 12.9168 20.0002 12.9168C22.2943 12.9168 23.7502 14.4264 23.7502 15.8335C23.7502 16.5239 24.3098 17.0835 25.0002 17.0835C25.6905 17.0835 26.2502 16.5239 26.2502 15.8335C26.2502 13.0562 23.9675 11.0146 21.2502 10.5281V10.0002Z" fill="#000D00"/>
  //                   </svg>
  //               `;
  //           }else if(_subStatusListData.rma_order_sub_status_info.son_status_description_show == 'Reshipment in transit' || _subStatusListData.rma_order_sub_status_info.son_status_description_show == 'In transit'){
  //               console.log('在途',_subStatusListData.rma_order_sub_status_info.son_status_description_show);
  //               no_oldSvg.outerHTML = `
  //                   <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
  //                       <path d="M31.091 27.1359C32.8847 27.1359 34.3584 28.4844 34.3584 30.1253C34.3584 31.7666 32.9089 33.115 31.091 33.115C29.2976 33.115 27.8235 31.789 27.8235 30.1253C27.8235 28.4844 29.273 27.1359 31.091 27.1359ZM4.63762 6.17188H22.4089V28.0123H14.7104C14.0962 26.0566 12.131 24.5958 9.77226 24.5958C7.41354 24.5958 5.44831 26.0341 4.83413 28.0123H2.74582V7.90302C2.74582 6.95886 3.60576 6.17188 4.63762 6.17188ZM9.7723 27.1359C11.5902 27.1359 13.0639 28.4844 13.0398 30.1253C13.0398 31.7666 11.5902 33.115 9.7723 33.115C7.97852 33.115 6.50487 31.789 6.50487 30.1253C6.50483 28.4844 7.95433 27.1359 9.7723 27.1359ZM37.1836 18.5715V28.0123H36.0537C35.4395 26.0566 33.4497 24.5959 31.091 24.5959C28.7326 24.5959 26.7424 26.0342 26.1282 28.0123H24.8799V10.007H27.7989C32.9823 10.0069 37.1836 13.851 37.1836 18.5715ZM27.7989 20.2797H34.3584V18.5715C34.3584 15.7169 31.8282 13.4238 28.7326 13.4238H27.7989V20.2797Z" fill="#000D00"/>
  //                   </svg>
  //               `;
  //           }else if(_subStatusListData.rma_order_sub_status_info.son_status_description_show == 'Reshipment delivered' || _subStatusListData.rma_order_sub_status_info.son_status_description_show == 'Delivered'){
  //               no_oldSvg.outerHTML = `
  //                   <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
  //                       <path d="M31.091 27.1359C32.8847 27.1359 34.3584 28.4844 34.3584 30.1253C34.3584 31.7666 32.9089 33.115 31.091 33.115C29.2976 33.115 27.8235 31.789 27.8235 30.1253C27.8235 28.4844 29.273 27.1359 31.091 27.1359ZM4.63762 6.17188H22.4089V28.0123H14.7104C14.0962 26.0566 12.131 24.5958 9.77226 24.5958C7.41354 24.5958 5.44831 26.0341 4.83413 28.0123H2.74582V7.90302C2.74582 6.95886 3.60576 6.17188 4.63762 6.17188ZM9.7723 27.1359C11.5902 27.1359 13.0639 28.4844 13.0398 30.1253C13.0398 31.7666 11.5902 33.115 9.7723 33.115C7.97852 33.115 6.50487 31.789 6.50487 30.1253C6.50483 28.4844 7.95433 27.1359 9.7723 27.1359ZM37.1836 18.5715V28.0123H36.0537C35.4395 26.0566 33.4497 24.5959 31.091 24.5959C28.7326 24.5959 26.7424 26.0342 26.1282 28.0123H24.8799V10.007H27.7989C32.9823 10.0069 37.1836 13.851 37.1836 18.5715ZM27.7989 20.2797H34.3584V18.5715C34.3584 15.7169 31.8282 13.4238 28.7326 13.4238H27.7989V20.2797Z" fill="#000D00"/>
  //                   </svg>
  //               `;
  //           }
  //       }
  //       const warningEls = document.querySelectorAll('.warning-icon-title');
  //       if (warningEls.length) {
  //         warningEls.forEach(el => el.textContent = _subStatusListData.rma_order_sub_status_info.son_status_description_show );
  //       }
  //       // document.querySelector(".no-sub-state .warning-icon-title") &&(document.querySelector(".no-sub-state .warning-icon-title").textContent = _subStatusListData.rma_order_sub_status_info.son_status_description_show);
  //       document.querySelector(".warning-icon-title-three")?.classList.add("hidden");
  //     } else {
  //       const container = document.querySelector(".has-sub-state");
  //       if (container) {
  //         container.insertAdjacentHTML("afterbegin", `
  //           <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
  //             <path fill-rule="evenodd" clip-rule="evenodd"
  //               d="M20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0ZM18 10H22V22H18V10ZM18 26H22V30H18V26Z"
  //               fill="#FF9900"/>
  //           </svg>
  //         `);
  //       }
  //     }
  //     // 对应提示
  //     document.querySelector(".warning-icon-title-three") &&(document.querySelector(".warning-icon-title-three").textContent = "There will be customer contacting you soon");
  //   }
  // }
}
// 需要显示确认按钮
function showConfirmRefund() {
  if (!_rmaOrderInfo || !_subStatusListData) return;
  const isPreConfirm = Number(_rmaOrderInfo.is_pre_refund_confirm); // 是否已确认预估退款，1：接受，2：不接受，0：未确认
  const isShowAfter = Number(
    _subStatusListData.is_show_pre_refund_confirm_after
  ); // 1 客服确认中， 0 客服确认完成
  //  isPreRefundConfirm ：1 已确认， 2 已拒绝 showConfirmRefundAfter：1 客服确认中 0 客服未确认
  if ((isPreConfirm === 1 || isPreConfirm === 2) && isShowAfter === 1) {
    return true;
  } else {
    return false;
  }
}
// 刚提交未确认
function showStartSubmit() {
  if (!_rmaOrderInfo || !_subStatusListData) return;
  const isPreConfirm = Number(_rmaOrderInfo.is_pre_refund_confirm); // 是否已确认预估退款，1：接受，2：不接受，0：未确认
  const isShowAfter = Number(
    _subStatusListData.is_show_pre_refund_confirm_after
  ); // 1 客服确认中， 0 客服确认完成
  return isPreConfirm === 0 && _rmaOrderInfo.pre_refund_amount === "0.00";
}
// 已经提交，看是否确认
function confirmRefundText() {
  if (!_rmaOrderInfo || !_subStatusListData) return;
  const isPreConfirm = Number(_rmaOrderInfo.is_pre_refund_confirm); // 是否已确认预估退款，1：接受，2：不接受，0：未确认
  const isShowAfter = Number(
    _subStatusListData.is_show_pre_refund_confirm_after
  ); // 1 客服确认中， 0 客服确认完成
  let text = "";
  if (isShowAfter === 1) {
    if (isPreConfirm === 1) {
      text = "the refund will be issued within 24-48hours about";
    } else if (isPreConfirm === 2) {
      text = "there will be customer service contacting you soon";
    }
  }
  return text;
}
// 已完成
function finishIcon() {
  if (!_rmaOrderInfo || !_subStatusListData) return;
  const isPreConfirm = Number(_rmaOrderInfo.is_pre_refund_confirm); // 是否已确认预估退款，1：接受，2：不接受，0：未确认
  const isShowAfter = Number(
    _subStatusListData.is_show_pre_refund_confirm_after
  ); // 1 客服确认中， 0 客服确认完成
  return (
    _subStatusListData?.rma_order_sub_status_info.son_status_description_show?.indexOf(
      "Refund processing"
    ) > -1 ||
    _subStatusListData?.rma_order_sub_status_info.son_status_description_show?.indexOf(
      "Refund fulfilled"
    ) > -1 ||
    _rmaOrderInfo?.status === 3 ||
    _rmaOrderInfo?.status === 4
  );
}
// 已交付
function deliveredIcon() {
  let text =
    _subStatusListData?.rma_order_sub_status_info.son_status_description_show?.toLowerCase();
  return text?.indexOf("delivered") > -1 && _rmaOrderInfo?.status === 2;
}
// 运输途中显示车运输图标
function carIcon() {
  let text =
    _subStatusListData?.rma_order_sub_status_info.son_status_description_show?.toLowerCase();
  return text?.indexOf("transit") > -1 && _rmaOrderInfo?.status === 2;
}

// ================== 初始化：获取 rmaOrderInfo（并保存到 localStorage） ==================
// 这里保留你原先的逻辑：通过页面信息组装 orderParams，然后调用 getRmaOrderItemInfo
async function fetchRmaOrderDetailAndCache() {
  console.log("子状态");
  const orderName = sessionStorage.getItem("order_name");
  const orderId = window.getQueryParam("order_id");
  const variantId = window.getQueryParam("variant_id");
  const productId = window.getQueryParam("product_id");
  const customerEmail = window.customerData?.email || "";

  const orderParams = {
    order_name: orderName,
    order_item_id: orderId,
    order_productId: productId,
    order_variant_id: variantId,
    customer_email: customerEmail,
  };

  try {
    const data = await getRmaOrderItemInfo(orderParams);

    console.log("开始请求 getRmaOrderItemInfo 获取订单详情", data);

    if (!data || !data.data || !data.data.rma_order) {
      console.warn("getRmaOrderItemInfo 返回数据不完整", data);
      return null;
    }

    _rmaOrderInfo = data.data.rma_order;

    // 保存 localStorage
    try {
      localStorage.setItem("rma_order_data", JSON.stringify(_rmaOrderInfo));
    } catch (e) {
      console.warn("保存 rma_order_data 到 localStorage 失败：", e);
    }

    console.log("商品详情数据：", _rmaOrderInfo);

    // 渲染图标
    checkAndShowRefundConfirmIcon();

    // 关键点：返回 JSON.stringify(_rmaOrderInfo)
    return JSON.stringify(_rmaOrderInfo);
  } catch (err) {
    console.error("getRmaOrderItemInfo 请求出错：", err);
    return null;
  }
}

// ================== DOMContentLoaded：读取 localStorage（兼容旧逻辑）并做基础渲染 ========
document.addEventListener("DOMContentLoaded", function () {
  console.log("获取rma内容");
  order_status(rmaId); // 在页面加载时调用
  // const rmaOrderData = getLatestRmaOrderData();
  // if (rmaOrderData) {
  //   console.log("取到的 rma_order 数据（来自 localStorage）：", rmaOrderData);

  //   // 保持你原有的界面调整逻辑（隐藏/显示按钮、设置文本等）
  //   const btn = document.querySelector(".show-information-money-btn");
  //   const btn_word_tips = document.querySelector(".button-instruction");
  //   if(rmaOrderData.shipping_label_image){
  //       // 如果货运单存在显示查看货运单的按钮
  //         // ✅ 批量给所有 .view-way-bill-pic 元素赋值并添加点击事件
  //         const wayBillBtns = document.querySelectorAll(".view-way-bill-pic");
  //         if (wayBillBtns.length > 0) {
  //           wayBillBtns.forEach(billBtn => {
  //             // 设置 data-image
  //             if (rmaOrderData.shipping_label_image) {
  //               billBtn?.classList.remove("hidden");
  //               billBtn.dataset.image = rmaOrderData.shipping_label_image;
  //             }
  //           })
  //         }
  //   }
  //   if (Number(rmaOrderData.is_pre_refund_confirm) === 1 || Number(rmaOrderData.is_pre_refund_confirm) === 2) {
  //     if (btn) btn.classList.add("hidden");
  //     if (btn_word_tips) btn_word_tips.classList.add("hidden");
  //     document.querySelector(".button-instructions")?.classList.add("hidden");
  //     document.querySelector(".show-information-money")?.classList.add("hidden");
  //     document.querySelector(".warning-icon-title-three")?.classList.remove("hidden");
  //     document.querySelector(".has-sub-state .empty-height")?.classList.remove("hidden");
  //     document.querySelector(".has-sub-state .warning-icon-title") &&(document.querySelector(".has-sub-state .warning-icon-title").textContent = "Request Submitted");
  //     const oldSvg = document.querySelector('.has-sub-state svg');
  //     if (oldSvg) {
  //       oldSvg.outerHTML = `
  //         <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
  //           <path fill-rule="evenodd" clip-rule="evenodd"
  //             d="M17.0002 33.6668C26.2049 33.6668 33.6668 26.2049 33.6668 17.0002C33.6668 7.79542 26.2049 0.333496 17.0002 0.333496C7.79542 0.333496 0.333496 7.79542 0.333496 17.0002C0.333496 26.2049 7.79542 33.6668 17.0002 33.6668ZM21.9496 11.9496C22.4378 11.4615 23.2292 11.4615 23.7174 11.9496C24.2055 12.4378 24.2055 13.2292 23.7174 13.7174L15.384 22.0507C14.8959 22.5389 14.1044 22.5389 13.6163 22.0507L10.2829 18.7174C9.79479 18.2292 9.79479 17.4378 10.2829 16.9496C10.7711 16.4615 11.5626 16.4615 12.0507 16.9496L14.5002 19.3991L21.9496 11.9496Z"
  //             fill="#00CC13"/>
  //         </svg>
  //       `;
  //     }
  //     if (Number(rmaOrderData.is_pre_refund_confirm) === 2) {
  //       document.querySelector(".warning-icon-title-three") &&(document.querySelector(".warning-icon-title-three").textContent = "There will be customer concatcing you soon");
  //     }
  //   } else {
  //     if (btn) btn.classList.remove("hidden");
  //     if (btn_word_tips) btn_word_tips.classList.remove("hidden");
  //   }

  //   // 包装状态
  //   if (rmaOrderData.package_opened == 0) {
  //     document.querySelector(".return-types .Status-item .message-word").textContent = 'Unused';
  //   } else {
  //     document.querySelector(".return-types .Status-item .message-word").textContent = 'Used';
  //   }

  //   // 请求类型
  //   if (rmaOrderData.request_type == 1) {
  //     document.querySelector(".return-types .return-request-types-cen .request-type .message-word").textContent = 'Refund (No Returns Required)';
  //   } else if (rmaOrderData.request_type == 2) {
  //     document.querySelector(".return-types .return-request-types-cen .request-type .message-word").textContent = 'Refund (With Returns)';
  //   } else if (rmaOrderData.request_type == 3) {
  //     document.querySelector(".return-types .return-request-types-cen .request-type .message-word").textContent = 'Exchange Product';
  //   }

  //   // 理由
  //   if (rmaOrderData.reason) {
  //     let reasonText = rmaOrderData.reason;
  //     if (rmaOrderData.reason_sub) reasonText += " -- " + rmaOrderData.reason_sub;
  //     document.querySelector(".return-types .Reason-type .message-word").textContent = reasonText;
  //   }

  //   // 评论上传图片渲染
  //   const container = document.querySelector(".message-pic-cen");
  //   if (container) {
  //     container.innerHTML = "";
  //     let hasImage = false;
  //     if (Array.isArray(rmaOrderData.rma_comment)) {
  //       rmaOrderData.rma_comment.forEach(comment => {
  //         if (comment.attachments) {
  //           const img = document.createElement("img");
  //           img.src = comment.attachments;
  //           img.alt = "Comment Attachment";
  //           container.appendChild(img);
  //           hasImage = true;
  //         }
  //       });
  //     }
  //     container.style.display = hasImage ? "" : "none";
  //   }
  // }
  // if rmaOrderData
});

// ================== 使用 order_status 渲染子状态、时间线、以及 pre_refund_confirm 功能 ==================
// order_status(rmaId).then((data) => {
//   if (!data || !data.data) return;

//   // 缓存子状态数据（用于联合判断）
//   _subStatusListData = data.data;
//   // 收到子状态数据后尝试渲染联合图标
//   checkAndShowRefundConfirmIcon();

//   // ========== 渲染子状态信息 ==========
//   const subStatusInfo = data.data?.rma_order_sub_status_info;

//   const container = document.querySelector(
//     ".sub-state .return-request-types-cen"
//   );

//   if (subStatusInfo && container) {
//     document.querySelector(".sub-state")?.classList.remove("hidden");

//     // 清空原本的内容
//     container.innerHTML = "";

//     // 状态 (Status)
//     if (subStatusInfo.son_status_description_show) {
//       container.innerHTML += `
//         <div class="form-section Status-item cen">
//           <h3 class="form-title message-title">Status</h3>
//           <div class="message-word">${subStatusInfo.son_status_description_show}</div>
//         </div>`;
//     }

//     // Case Id
//     if (subStatusInfo.case_id) {
//       container.innerHTML += `
//         <div class="form-section CaseId-type cen">
//           <h3 class="form-title message-title">Case Id</h3>
//           <div class="message-word">${subStatusInfo.case_id}</div>
//         </div>`;
//     }

//     // Condition of Returned Item
//     if (subStatusInfo.arrival_status) {
//       container.innerHTML += `
//         <div class="form-section request-type cen">
//           <h3 class="form-title message-title">Condition Of Returned Item
//             <svg class="show-condition-popup" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
//               <path fill-rule="evenodd" clip-rule="evenodd" d="M2.125 9C2.125 5.20304 5.20304 2.125 9 2.125C12.797 2.125 15.875 5.20304 15.875 9C15.875 12.797 12.797 15.875 9 15.875C5.20304 15.875 2.125 12.797 2.125 9ZM9 0.875C4.51269 0.875 0.875 4.51269 0.875 9C0.875 13.4873 4.51269 17.125 9 17.125C13.4873 17.125 17.125 13.4873 17.125 9C17.125 4.51269 13.4873 0.875 9 0.875ZM9.9375 13.0625C9.9375 13.5803 9.51777 14 9 14C8.48223 14 8.0625 13.5803 8.0625 13.0625C8.0625 12.5447 8.48223 12.125 9 12.125C9.51777 12.125 9.9375 12.5447 9.9375 13.0625ZM7.9237 4.83909C8.43762 4.62622 9.00312 4.57052 9.54869 4.67904C10.0943 4.78756 10.5954 5.05543 10.9887 5.44876C11.3821 5.8421 11.6499 6.34324 11.7585 6.88881C11.867 7.43438 11.8113 7.99988 11.5984 8.5138C11.3855 9.02771 11.0251 9.46697 10.5625 9.77601C10.2758 9.96761 9.95782 10.1038 9.625 10.1797V10.875H8.375V9.625C8.375 9.45924 8.44085 9.30027 8.55806 9.18306C8.67527 9.06585 8.83424 9 9 9C9.30903 9 9.61113 8.90836 9.86808 8.73667C10.125 8.56498 10.3253 8.32095 10.4436 8.03544C10.5618 7.74993 10.5928 7.43577 10.5325 7.13267C10.4722 6.82958 10.3234 6.55117 10.1049 6.33265C9.88634 6.11413 9.60792 5.96531 9.30483 5.90502C9.00173 5.84473 8.68757 5.87568 8.40206 5.99394C8.11655 6.1122 7.87252 6.31247 7.70083 6.56942C7.52914 6.82638 7.4375 7.12847 7.4375 7.4375V8.0625H6.1875V7.4375C6.1875 6.88124 6.35245 6.33747 6.66149 5.87496C6.97053 5.41245 7.40979 5.05196 7.9237 4.83909Z" fill="#B9B9B9"/>
//             </svg>
//           </h3>
//           <div class="message-word">${subStatusInfo.arrival_status}</div>
//         </div>`;
//     }

//     // Estimated Refund Amount
//     if (subStatusInfo.estimated_refund_amount > 0) {
//       container.innerHTML += `
//         <div class="form-section Reason-type cen">
//           <h3 class="form-title message-title">Estimated Refund Amount</h3>
//           <div class="message-word">$${subStatusInfo.estimated_refund_amount}</div>
//         </div>`;
//     }

//     // Refund Amount
//     if (subStatusInfo.refund_amount > 0) {
//       container.innerHTML += `
//         <div class="form-section Refund-type cen">
//           <h3 class="form-title message-title">Refund Amount</h3>
//           <div class="message-word">$${subStatusInfo.refund_amount}</div>
//         </div>`;
//     }

//     // Shipping Company
//     if (subStatusInfo.carrier_code) {
//       container.innerHTML += `
//         <div class="form-section Carrier-type cen">
//           <h3 class="form-title message-title">Shipping Company</h3>
//           <div class="message-word">${subStatusInfo.carrier_code}</div>
//         </div>`;
//     }

//     // Tracking Number
//     if (subStatusInfo.tracking_code) {
//       container.innerHTML += `
//         <div class="form-section Tracking-type cen">
//           <h3 class="form-title message-title">Tracking Number</h3>
//           <div class="message-word">${subStatusInfo.tracking_code}</div>
//         </div>`;
//     }

//     // Product (SKU)
//     if (subStatusInfo.sku) {
//       container.innerHTML += `
//         <div class="form-section Product-type cen">
//           <h3 class="form-title message-title">Product</h3>
//           <div class="message-word">${subStatusInfo.sku}</div>
//         </div>`;
//     }

//     // Name
//     if (subStatusInfo.name) {
//       container.innerHTML += `
//         <div class="form-section Name-type cen">
//           <h3 class="form-title message-title">Name</h3>
//           <div class="message-word">${subStatusInfo.name}</div>
//         </div>`;
//     }

//     // Phone
//     if (subStatusInfo.phone) {
//       container.innerHTML += `
//         <div class="form-section Phone-type cen">
//           <h3 class="form-title message-title">Phone Number</h3>
//           <div class="message-word">${subStatusInfo.phone}</div>
//         </div>`;
//     }

//     // Region / State
//     if (subStatusInfo.region) {
//       container.innerHTML += `
//         <div class="form-section Region-type cen">
//           <h3 class="form-title message-title">State</h3>
//           <div class="message-word">${subStatusInfo.region}</div>
//         </div>`;
//     }

//     // Country
//     if (subStatusInfo.country) {
//       container.innerHTML += `
//         <div class="form-section Country-type cen">
//           <h3 class="form-title message-title">Country</h3>
//           <div class="message-word">${subStatusInfo.country}</div>
//         </div>`;
//     }

//     // City
//     if (subStatusInfo.city) {
//       container.innerHTML += `
//         <div class="form-section City-type cen">
//           <h3 class="form-title message-title">City</h3>
//           <div class="message-word">${subStatusInfo.city}</div>
//         </div>`;
//     }

//     // Zip Code
//     if (subStatusInfo.postcode) {
//       container.innerHTML += `
//         <div class="form-section Zip-type cen">
//           <h3 class="form-title message-title">Zip Code</h3>
//           <div class="message-word">${subStatusInfo.postcode}</div>
//         </div>`;
//     }

//     // Street / Address
//     if (subStatusInfo.street) {
//       container.innerHTML += `
//         <div class="form-section Address-type cen">
//           <h3 class="form-title message-title">Address</h3>
//           <div class="message-word">${subStatusInfo.street}</div>
//         </div>`;
//     }

//     // Shipping Details
//     if (
//       subStatusInfo.shipping_details &&
//       Array.isArray(subStatusInfo.shipping_details) &&
//       subStatusInfo.shipping_details.length
//     ) {
//       let shippingHtml = subStatusInfo.shipping_details
//         .map(
//           (item) => `
//         <div class="form-section ShippingDetail-type cen">
//           <h3 class="form-title message-title">${item.time}</h3>
//           <div class="message-word">${item.status}</div>
//         </div>`
//         )
//         .join("");
//       container.innerHTML += shippingHtml;
//     }
//   } else {
//     // document
//     //   .querySelectorAll(".show-information-warning-icon svg")
//     //   .forEach((svg) => {
//     //     svg.outerHTML = `
//     //     <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
//     //       <path fill-rule="evenodd" clip-rule="evenodd" d="M20.0002 36.6668C29.2049 36.6668 36.6668 29.2049 36.6668 20.0002C36.6668 10.7954 29.2049 3.3335 20.0002 3.3335C10.7954 3.3335 3.3335 10.7954 3.3335 20.0002C3.3335 29.2049 10.7954 36.6668 20.0002 36.6668ZM24.9496 14.9496C25.4378 14.4615 26.2292 14.4615 26.7174 14.9496C27.2055 15.4378 27.2055 16.2292 26.7174 16.7174L18.384 25.0507C17.8959 25.5389 17.1044 25.5389 16.6163 25.0507L13.2829 21.7174C12.7948 21.2292 12.7948 20.4378 13.2829 19.9496C13.7711 19.4615 14.5626 19.4615 15.0507 19.9496L17.5002 22.3991L24.9496 14.9496Z" fill="#00CC13"/>
//     //     </svg>
//     //   `;
//     //   });
//     // document.querySelector(".warning-icon-title-two")?.classList.remove("hidden");
//     document
//       .querySelector(".warning-icon-title-three")
//       ?.classList.add("hidden");
//     const warningEls = document.querySelectorAll(".warning-icon-title");
//     if (warningEls.length) {
//       warningEls.forEach((el) => (el.textContent = "Request Submitted"));
//     }
//     // document.querySelector(".has-sub-state .warning-icon-title") && (document.querySelector(".has-sub-state .warning-icon-title").textContent = "Your Application In Progress");
//   }

//   // ========== 渲染时间线（根据 rma_order_sub_status_history 动态生成多个模块） ==========

//   const statusWrap = document.querySelector(".status-update.cen");
//   if (!statusWrap) return;

//   // 清空旧内容（重新渲染）
//   statusWrap.innerHTML = "";

//   // 获取状态历史数据
//   const historyList = data.data?.rma_order_sub_status_history || [];
//   if (!historyList.length) {
//     statusWrap.innerHTML = `<p class="no-history">No status history available.</p>`;
//     return;
//   }

//   // 读取 RMA 主状态（用于判断是否追加 “Waiting...”）
//   let rmaOrderData = null;
//   try {
//     rmaOrderData = getLatestRmaOrderData();
//   } catch (e) {
//     console.warn("rma_order_data 解析失败：", e);
//   } // 如果 localStorage 没拿到，尝试从当前接口返回兜底
//   if (!rmaOrderData) {
//     rmaOrderData = data.data?.rma_order_info || {};
//   }
//   console.log("获取子订单内容", rmaOrderData, rmaOrderData.pre_refund_amount);
//   // 如果存在估算退款金额则显示交互按钮区域
//   const refundAmount =
//     Number(rmaOrderData?.pre_refund_amount) ||
//     Number(data.data?.rma_order_sub_status_info?.estimated_refund_amount);

//   // console.log('获取预估退款金额',refundAmount);
//   // // if (refundAmount > 0) {
//   // //   console.log('存在预估退款金额02',data.data?.rma_order_sub_status_info?.estimated_refund_amount,rmaOrderData?.pre_refund_amount);
//   // //   // 预估退款金额大于0
//   // // // if (Number(data.data?.rma_order_sub_status_info?.estimated_refund_amount) > 0) {
//   // //   document.querySelector(".has-sub-state")?.classList.remove("hidden");
//   // //   document.querySelector(".no-sub-state")?.classList.add("hidden");
//   // //   const moneyEl = document.querySelector(".show-information-money");
//   // //   if (moneyEl) {
//   // //     moneyEl.textContent = '$'+ rmaOrderData?.pre_refund_amount; // 设置显示的值

//   // //     const btnAccept = document.querySelector(".btn-accept");
//   // //     const btnReject = document.querySelector(".btn-accept-no");

//   // //     async function preRefundConfirm(is_accept) {
//   // //       const url = "https://plugin.kriyya.com/api/klaiyi/rma/pre_refund_confirm";
//   // //       try {
//   // //         const res = await fetch(url, {
//   // //           method: "POST",
//   // //           headers: {
//   // //             "Content-Type": "application/x-www-form-urlencoded",
//   // //             "Authorization": "Bearer 6JXquydq6hZG4aJyN8A5"
//   // //           },
//   // //           body: new URLSearchParams({
//   // //             rma_id: rmaId,
//   // //             is_accept
//   // //           }).toString()
//   // //         });

//   // //         const resJson = await res.json();
//   // //         console.log("确认接口返回：", resJson);

//   // //         if (resJson.code === 200000) {
//   // //           console.log(is_accept == 1 ? "已接受退款金额" : "已拒绝退款金额");

//   // //           // 成功后隐藏按钮并显示提交状态（与前面一致）
//   // //           document.querySelector(".show-information-money-btn")?.classList.add("hidden");
//   // //           document.querySelector(".button-instruction")?.classList.add("hidden");
//   // //           document.querySelector(".button-instructions")?.classList.add("hidden");
//   // //           document.querySelector(".show-information-money")?.classList.add("hidden");
//   // //           document.querySelector(".warning-icon-title-three")?.classList.remove("hidden");
//   // //           document.querySelector(".has-sub-state .empty-height")?.classList.remove("hidden");
//   // //           const warningEls = document.querySelectorAll('.warning-icon-title');
//   // //           if (warningEls.length) {
//   // //             warningEls.forEach(el => el.textContent = "Request Submitted" );
//   // //           }
//   // //           // document.querySelector(".has-sub-state .warning-icon-title") && (document.querySelector(".has-sub-state .warning-icon-title").textContent = "Request Submitted");

//   // //           const oldSvg = document.querySelector('.has-sub-state svg');
//   // //           if (oldSvg) {
//   // //             oldSvg.outerHTML = is_accept == 1 ? `
//   // //               <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
//   // //                 <path fill-rule="evenodd" clip-rule="evenodd"
//   // //                   d="M17.0002 33.6668C26.2049 33.6668 33.6668 26.2049 33.6668 17.0002C33.6668 7.79542 26.2049 0.333496 17.0002 0.333496C7.79542 0.333496 0.333496 7.79542 0.333496 17.0002C0.333496 26.2049 7.79542 33.6668 17.0002 33.6668ZM21.9496 11.9496C22.4378 11.4615 23.2292 11.4615 23.7174 11.9496C24.2055 12.4378 24.2055 13.2292 23.7174 13.7174L15.384 22.0507C14.8959 22.5389 14.1044 22.5389 13.6163 22.0507L10.2829 18.7174C9.79479 18.2292 9.79479 17.4378 10.2829 16.9496C10.7711 16.4615 11.5626 16.4615 12.0507 16.9496L14.5002 19.3991L21.9496 11.9496Z"
//   // //                   fill="#00CC13"/>
//   // //               </svg>
//   // //             ` : `
//   // //               <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
//   // //                 <path fill-rule="evenodd" clip-rule="evenodd"
//   // //                   d="M20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0ZM18 10H22V22H18V10ZM18 26H22V30H18V26Z"
//   // //                   fill="#FF9900"/>
//   // //               </svg>
//   // //             `;
//   // //           }

//   // //           if (is_accept == 0) {
//   // //             document.querySelector(".warning-icon-title-three") &&
//   // //             (document.querySelector(".warning-icon-title-three").textContent = "There will be customer contacting you soon");
//   // //           }

//   // //           // 更新本地缓存中的 rma_order_data.is_pre_refund_confirm，以便后续逻辑判断
//   // //           try {
//   // //             const localData = getLatestRmaOrderData() || {};
//   // //             localData.is_pre_refund_confirm = String(is_accept);
//   // //             localStorage.setItem("rma_order_data", JSON.stringify(localData));
//   // //             // 同步内存变量（如果有）
//   // //             if (_rmaOrderInfo) _rmaOrderInfo.is_pre_refund_confirm = String(is_accept);
//   // //           } catch (e) {
//   // //             console.warn("更新 localStorage rma_order_data 失败：", e);
//   // //           }

//   // //           // 收到确认后尝试与子状态联合判断（如果子状态数据存在）
//   // //           checkAndShowRefundConfirmIcon();

//   // //         } else {
//   // //           console.error(resJson.message || "操作失败，请稍后再试");
//   // //         }
//   // //       } catch (error) {
//   // //         console.error("调用确认接口出错：", error);
//   // //       }
//   // //     }

//   // //     if (btnAccept) {
//   // //       btnAccept.addEventListener("click", function () { preRefundConfirm(1); });
//   // //     }
//   // //     if (btnReject) {
//   // //       btnReject.addEventListener("click", function () { preRefundConfirm(0); });
//   // //     }
//   // //   }

//   // // }
//   // end if estimated_refund_amount

//   // 遍历每个 request_type（如 Return & Refund / Exchange）
//   historyList.forEach((historyItem, idx) => {
//     const topKeyword = historyItem.request_type_description_show || "—";
//     const subList = historyItem.sub_status_list || [];

//     // 容器结构
//     const cenDiv = document.createElement("div");
//     cenDiv.className = "status-update-cen";
//     if (idx > 0) cenDiv.classList.add("status-update-bottom"); // ✅ 第二个及之后加上额外class
//     cenDiv.innerHTML = `
//         <div class="status-update-cen-top">
//         <span class="status-update-cen-top-kayword">${topKeyword}</span>
//         <span class="status-update-cen-top-data hidden">${
//           subList[0]?.created_at_format || "--"
//         }</span>
//         </div>
//         <div class="status-update-cen-bottom">
//         <div class="timeline"></div>
//         </div>
//     `;

//     const timelineEl = cenDiv.querySelector(".timeline");

//     // 处理 Waiting... 逻辑
//     const allSubStatus = [...subList];
//     console.log("获取子状态", subList, rmaOrderData);
//     // 如果存在 Waiting 状态，插入前排序
//     if (rmaOrderData && rmaOrderData.status != 3 && rmaOrderData.status != 4) {
//       subList.push({
//         status_description_show: "Waiting...",
//         created_at_format: "--",
//         isWaiting: true,
//       });
//     }

//     // 将 isWaiting=true 的项排到最前面
//     subList.sort((a, b) => {
//       if (a.isWaiting && !b.isWaiting) return -1; // a 在前
//       if (!a.isWaiting && b.isWaiting) return 1; // b 在前
//       return 0; // 其他保持原顺序
//     });
//     console.log("获取所有子状态", subList);

//     // 倒序展示（最新在上）
//     subList.forEach((subStatus, index) => {
//       const itemDiv = document.createElement("div");
//       let statusClass = "";

//       if (index === 0 && !subStatus.isWaiting) statusClass = "active";
//       else if (!subStatus.isWaiting) statusClass = "completed";

//       const statusHTML = subStatus.status_description_show
//         ? `<p class="status">${subStatus.status_description_show}</p>`
//         : "";
//       const sonStatusHTML = subStatus.son_status_description_show
//         ? `<p class="time">${subStatus.son_status_description_show}</p>`
//         : "";
//       const createdAtHTML = subStatus.created_at_format
//         ? `<p class="time">${subStatus.created_at_format}</p>`
//         : "";

//       itemDiv.className = `timeline-item ${statusClass}`.trim();
//       itemDiv.innerHTML = `
//             <div class="dot"></div>
//             <div class="timeline-content">
//               ${statusHTML}
//               ${sonStatusHTML}
//               ${createdAtHTML}
//             </div>
//           `;

//       timelineEl.appendChild(itemDiv);
//     });

//     // subList.forEach((subStatus, index) => {
//     //     const itemDiv = document.createElement("div");
//     //     let statusClass = "";

//     //     if (index === 0 && !subStatus.isWaiting) statusClass = "active";
//     //     else if (!subStatus.isWaiting) statusClass = "completed";

//     //     itemDiv.className = `timeline-item ${statusClass}`.trim();
//     //     itemDiv.innerHTML = `
//     //     <div class="dot"></div>
//     //     <div class="timeline-content">
//     //         <p class="status">${subStatus.status_description_show || "Unknown Status"}</p>
//     //         <p class="time">${subStatus.son_status_description_show || "--"}</p>
//     //         <p class="time">${subStatus.created_at_format || "--"}</p>
//     //     </div>
//     //     `;
//     //     timelineEl.appendChild(itemDiv);
//     // });

//     // 把整个模块加进主容器
//     statusWrap.appendChild(cenDiv);
//     // const allSubStatus = [...subList];
//     // if (rmaOrderData && rmaOrderData.status != 3 && rmaOrderData.status != 4) {
//     //     allSubStatus.push({
//     //     status_description_show: "Waiting...",
//     //     created_at_format: "--",
//     //     isWaiting: true
//     //     });
//     // }

//     // // 倒序展示（最新在上）
//     // allSubStatus.reverse().forEach((subStatus, index) => {
//     //     const itemDiv = document.createElement("div");
//     //     let statusClass = "";

//     //     if (index === 0 && !subStatus.isWaiting) statusClass = "active";
//     //     else if (!subStatus.isWaiting) statusClass = "completed";

//     //     itemDiv.className = `timeline-item ${statusClass}`.trim();
//     //     itemDiv.innerHTML = `
//     //     <div class="dot"></div>
//     //     <div class="timeline-content">
//     //         <p class="status">${subStatus.status_description_show || "Unknown Status"}</p>
//     //         <p class="time">${subStatus.created_at_format || "--"}</p>
//     //     </div>
//     //     `;
//     //     timelineEl.appendChild(itemDiv);
//     // });

//     // // 把整个模块加进主容器
//     // statusWrap.appendChild(cenDiv);
//   });

//   // ========== 渲染时间线 ==========
//   //   const timelineContainer = document.querySelector(".status-update-cen-bottom .timeline");
//   //   if (!timelineContainer) return;

//   //   timelineContainer.innerHTML = "";

//   //   const historyList = data.data?.rma_order_sub_status_history || [];
//   //   if (historyList.length) {
//   //     document.querySelector(".status-update-cen-top .status-update-cen-top-kayword").textContent = historyList[0].request_type_description_show || "";
//   //   }

//   //   let allSubStatus = [];
//   //   historyList.forEach(historyItem => {
//   //     const subList = historyItem.sub_status_list || [];
//   //     subList.forEach(subStatus => allSubStatus.push(subStatus));
//   //   });

//   //   // 若 rma_order_data 中 status 非 3 且 非 4，则追加 Waiting...
//   //   let rmaOrderData = null;
//   //   try {
//   //     rmaOrderData = getLatestRmaOrderData();
//   //     console.log("当前最新的 RMA 数据：", rmaOrderData);
//   //   } catch (e) {
//   //     console.warn("rma_order_data 解析失败：", e);
//   //   }

//   //   if (rmaOrderData && rmaOrderData.status != 3 && rmaOrderData.status != 4) {
//   //     allSubStatus.push({
//   //       status_description_show: "Waiting...",
//   //       created_at_format: "--",
//   //       isWaiting: true
//   //     });
//   //   }

//   //   // 倒序展示（最新在上）
//   //   allSubStatus.reverse().forEach((subStatus, index) => {
//   //     const itemDiv = document.createElement("div");
//   //     let statusClass = "";

//   //     if (index === 0 && !subStatus.isWaiting) statusClass = "active";
//   //     else if (!subStatus.isWaiting) statusClass = "completed";

//   //     itemDiv.className = `timeline-item ${statusClass}`.trim();
//   //     itemDiv.innerHTML = `
//   //       <div class="dot"></div>
//   //       <div class="timeline-content">
//   //         <p class="status">${subStatus.status_description_show || "Unknown Status"}</p>
//   //         <p class="time">${subStatus.created_at_format || "--"}</p>
//   //       </div>
//   //     `;

//   //     timelineContainer.appendChild(itemDiv);
//   //   });
// });
// end order_status.then
// 点击 info 图标 → 打开公共提示弹窗
document.addEventListener("click", (e) => {
  if (e.target.closest(".show-condition-popup")) {
    console.log("点击svg,弹出弹窗");

    window.SurePopup?.open({
      title: "Description Of Item's Condition",
      text: `
        <ul style="text-align: left; margin: 0; list-style: inside;">
          <li>RS: Returned in intact condition</li>
          <li>FC1: Returned in damaged but repairable condition</li>
          <li>FC2: Returned in damaged and irreparable condition</li>
        </ul>
      `,
      // 这里隐藏左按钮
      leftText: "",
      rightText: "OK",
      zIndex: 181,
      showClose: true,
      showMask: true,

      onConfirm() {
        // 点击 OK 自动关闭
        window.SurePopup?.close();
      },

      onCancel() {
        // 点击遮罩或关闭按钮自动关闭
        window.SurePopup?.close();
      },
    });
  }
});

// document.addEventListener("click", (e) => {
//   if (e.target.closest(".show-condition-popup")) {
//     console.log("点击svg,弹出弹窗");
//     const popup = document.querySelector(".sure-popup");
//     if (!popup) return;

//     // 设置提示内容（可以按需求动态修改）
//     popup.querySelector(".pop_title span").textContent = "Condition Info";
//     // 修改弹窗内容为三个 li
//     const contentEl = popup.querySelector(".sure-popup-main-word");
//     if (contentEl) {
//       contentEl.innerHTML = `
//          <ul style="text-align: left; margin: 0;list-style: inside;">
//            <li>RS: Returned in intact condition</li>
//            <li>FC1: Returned in damaged but repairable condition</li>
//            <li>FC2: Returned in damaged and irreparable condition</li>
//          </ul>
//        `;
//     }

//     // 显示弹窗
//     popup.classList.remove("none");
//     popup.querySelector(".sure_popup-btn-left").style.display = "none";
//     popup.querySelector(".pop_title span").textContent =
//       "Description Of Item's Condition";
//     popup.querySelector(".sure_popup-btn-right").textContent = "OK";
//     popup.querySelector(".sure_popup-btn-right").style.width = "100%";
//     // 显示遮罩层
//     const cover = popup.querySelector(".window-cover");
//     if (cover) {
//       cover.style.display = "block";
//     }

//     // 点击遮罩层或关闭按钮关闭
//     popup.querySelector(".window-cover").onclick = closePopup;
//     popup.querySelector(".iconfont.icon-Close").onclick = closePopup;
//     popup.querySelector(".sure_popup-btn-right").onclick = closePopup;
//   }
// });

// function closePopup() {
//   document.querySelector(".sure-popup").classList.add("none");
//   const cover = popup.querySelector(".window-cover");
//   if (cover) {
//     cover.style.display = "none";
//   }
// }

// 点击查看货运单
// document.querySelectorAll('.view-way-bill-pic').forEach(el => {
//     el.addEventListener('click', () => {
//       console.log('点击查看图片按钮')
//       // 获取目标 URL，可根据实际情况动态拼接
//       const btn = document.querySelectorAll('.view-way-bill-pic');
//       if (!btn) return;

//       const url = new URL(window.location.href);
//       const rmaId = url.searchParams.get('rma_id');
//       const variantId = url.searchParams.get('variant_id');
//       const productId = url.searchParams.get('product_id');
//       const orderId = url.searchParams.get('order_id');

//       // 拼接目标链接（根据实际需要带的参数）
//       const targetUrl = `https://www.klaiyihair.com/pages/refund-view-waybill?order_id=${orderId}&variant_id=${variantId}&product_id=${productId}&rma_id=${rmaId}`;
//       window.location.href = targetUrl;
//     });
// });

// ========== End of file ==========
